/**
 *
 * @param el
 * @return {{top: *, left: *}}
 */
function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    }
}


class ScrollSpy {

    constructor() {
        this.ratio = 0.7;
        this.observer = null;
        this.windowH = 0;
        this.windowW = 0;
        this.spies = null;
        this.init();
    }

    init(){
        this.spies = document.querySelectorAll("[data-spy]");
        this.windowH = window.innerHeight;
        this.windowW = window.innerWidth;

        if( this.spies.length > 0 ){
            this.spy();
            this.resize();
            this.navbar();
        }
    }

    render(target, isIntersecting, intersectionRatio){
        if( intersectionRatio > 0 ){
            const id = target.getAttribute("id");
            const anchor = document.querySelector(`a[href="#${id}"]`);
            if( anchor === null ){
                return null;
            }
            anchor.parentElement.querySelectorAll('.active').forEach(node => node.classList.remove('active'));
            anchor.classList.add("active");
            const left = anchor.offsetLeft;

            anchor.parentElement.scrollTo({
                left: left,
                behavior: "smooth"
            });
        }
    }

    resize(){
        const _this = this;
        window.addEventListener('resize', function(){
            if( window.innerHeight !== _this.windowH ){
                _this.spy();
                _this.windowH = window.innerHeight;
            }
            _this.windowW = window.innerWidth;
        })
    }


    /**
     *
     * @param NodelistOf.<Element>
     */
    spy(){
        const _this = this;
        if( this.observer !== null ){
            this.spies.forEach(function(spy){
                _this.observer.unobserve(spy);
            })
        }
        const y = Math.round(window.innerHeight * this.ratio);
        const options = {
            rootMargin: `-${window.innerHeight - y - 1}px 0px -${y}px 0px`,
        };
        this.observer = new IntersectionObserver(function(entries){
            entries.forEach(function (entry) {
                _this.render(entry.target, entry.isIntersecting, entry.intersectionRatio);
            })
        }, options);
        this.spies.forEach(function(spy){
            _this.observer.observe(spy);
        })
    }

    navbar(){
        const _this = this;
        this.spies.forEach((item) => {
            const id = item.getAttribute("id");
            const link = document.querySelector(`a[href="#${id}"]`);
            link.addEventListener('click', _this.callback);
        })
    }

    callback(e){
        e.preventDefault();
        const href = this.getAttribute("href");
        let element = document.querySelector(href);
        if( element == null ){
            element = document.querySelector(href);
        }
        const t = getOffset(element);
        const top = parseInt(t.top) - 100;
        window.scrollTo({
            top: top,
            behavior: "smooth"
        });
    }

}
new ScrollSpy();

